// extracted by mini-css-extract-plugin
export var body = "_od-8";
export var button = "_od-0";
export var closeButton = "_od-5";
export var content = "_od-3";
export var empty = "_od-f";
export var grid = "_od-c";
export var header = "_od-4";
export var icon = "_od-1";
export var option = "_od-d";
export var optionSelected = "_od-e";
export var overlay = "_od-2";
export var searchIcon = "_od-a";
export var searchInput = "_od-b";
export var searchWrapper = "_od-9";
export var title = "_od-6";
export var visuallyHidden = "_od-7";